// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-shadow{filter:drop-shadow(4px 4px 6px rgba(0,0,0,.5))}p.title{font-size:larger;text-align:center;padding:15px;border-bottom-width:1px;border-bottom-color:grey;margin-bottom:20px}.blur{filter:blur(3px);-webkit-filter:blur(3px)}.sp{display:none}.pc{display:block}@media screen and (max-width:768px){.sp{display:block}.pc{display:none}}@media (max-width:600px){.md-dialog-fullscreen{height:auto}}", ""]);
// Exports
module.exports = exports;
